import type { SegmentTrackExperimentViewedEvent } from "@beautypie/segment/Track/ExperimentViewed";
import type { TrackExperimentViewedEventType } from "@shared/graphql.types";
import { useCallback } from "react";
import { track } from "tracking/client";
import { mapGraphqlToSegmentTrackEvent } from "tracking/utils/mapGraphqlToSegmentEvent";

export type TrackExperimentViewed = (
  experimentId: string,
  experimentVariant: number,
  experimentVariantName?: string
) => void;

export type UseExperimentViewed = TrackExperimentViewed;

export function trackExperimentViewed(
  experimentId: string,
  experimentVariant: number,
  experimentVariantName?: string
): void {
  const key = `ExperimentViewed__${experimentId}__${experimentVariant}`;

  if (sessionStorage?.getItem(key)) return;

  track({
    event: "Experiment Viewed",
    properties: {
      experiment_id: experimentId,
      experiment_variant: experimentVariant,
      ...(experimentVariantName && {
        experiment_variant_name: experimentVariantName
      })
    }
  });

  sessionStorage.setItem(key, "1");
}

/**
 *
 * @param gqlEvent A BFF constructed TrackExperimentViewedEventType
 * @returns void
 */
export function trackExperimentViewedEvent(
  gqlEvent: TrackExperimentViewedEventType
): void {
  const event = mapGraphqlToSegmentTrackEvent(
    gqlEvent
  ) as SegmentTrackExperimentViewedEvent;

  if (event) {
    const key = `ExperimentViewed__${event.properties.experiment_id}__${event?.properties.experiment_variant}`;

    if (sessionStorage?.getItem(key)) return;

    track(event);

    sessionStorage.setItem(key, "1");
  }
}

export const useExperimentViewed = (): UseExperimentViewed => {
  const trackExperimentViewedCallback: TrackExperimentViewed = useCallback(
    trackExperimentViewed,
    []
  );

  return trackExperimentViewedCallback;
};
